export default {"src":"/_next/static/media/italic_info_gray.a10639ce.svg","height":17,"width":16,"blurWidth":0,"blurHeight":0};